// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Setting-__index-module___Main","CardContent":"src-containers-Setting-__index-module___CardContent"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Setting/index.module.css
// module id = 1261
// module chunks = 1